<div fxLayout="column" fxLayoutAlign="space-between stretch" fxFlexFill>
  <div fxFlex="0 0 auto" fxLayout="row" fxLayoutAlign="space-between">
    <unesp-core-header
      [showPinMenu]="true"
      fullTitle="{{ fullTitle }}"
      shortTitle="{{ shortTitle }}"
      logoCustom="{{ logoCustom }}"
      fxFlexFill></unesp-core-header>
  </div>
  <div fxFlex="1 1 auto">
    <unesp-core-sidenav fxFlexFill>
      <div class="ngcontent-content" fxFlexFill>
        <div [@routeAnimations]="prepareRoute(outlet)" style="padding: 20px">
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </div>
    </unesp-core-sidenav>
  </div>
  <div fxFlex="0 0 auto" fxLayout="row" id="unesp-core-footer">
    <unesp-core-footer fxFlexFill>
      <div class="ngcontent-select-footer">
        <address>
          <a
            href="https://www2.unesp.br/portal#!/propg"
            target="_blank"
            aria-label="Área responsável: PROPG"
            title="Área responsável: PROPG - Pró-reitoria de Pós-graduação"
            >PROPG</a
          >
          |
          <a
            href="https://www2.unesp.br/portal#!/ctinf"
            target="_blank"
            aria-label="Proprietário: CTINF"
            title="Proprietário: CTINF - Coordenadoria de Tecnlogia da Informação"
            >CTINF</a
          >
          |
          <a
            href="https://www2.unesp.br/portal#!/gtdsi"
            target="_blank"
            aria-label="Desenvolvido por: GTDSI"
            title="Desenvolvido por: GTDSI - Grupo Técnico de Desenvolvimento de Sistemas Institucionais"
            >GTDSI</a
          >
        </address>
      </div>
    </unesp-core-footer>
  </div>
</div>
